module.exports = __webpack_public_path__ + "media/images/icons/instagram_icon-13372b23697a0fec639f94d3636021e3.svg";